import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import logo from '../../Assets/navbarlogo/EMPlogo2.png'

function CollapsibleExample() {
  return (
    <Navbar collapseOnSelect expand="lg" className="bg-body-tertiary">
      <Container>
        <Navbar.Brand href="/"><img src={logo} className="img-fluid logo" alt="brand"/></Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto">
          </Nav>
          <Nav>
          <Nav.Link href="/">HOME</Nav.Link>
            <Nav.Link href="/about">ABOUT</Nav.Link>
            <Nav.Link href="/mission">MISSION</Nav.Link>
            {/* <Nav.Link href="/services">SERVICES</Nav.Link> */}
            <Nav.Link href="/contact">CONTACT</Nav.Link>
            <Nav.Link href="https://form.jotform.com/240776664139062">EMPLOYERS</Nav.Link>
            <Nav.Link href="https://form.jotform.com/240756041423146">APPLY</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default CollapsibleExample;